export default "/images/arrow-left.svg?e9b57e43022a3d0c8f20ce2588590afa";